/**
 * Created by rxsl-101 on 2018/3/20.
 */
import { MsgBox, Vue } from '../../app.vues';
import { Utils } from '../../app.base';
//
import servicerApi, { deleteAttTag } from '../../api/servicer';

import SwbComStaffSelect from './ComStaffSelect';
import SwbComStaffForSelect from './ComStaffForSelect';
import SwbServicerOrgTree from './ServicerOrgTree';
import SwbComStaffImpCheck from './ComStaffImpCheck';
import SwbComImpCheck from './ComImpCheck';
import SwbServicerEngineerListForSelect from './ServicerEngineerListForSelect';
import SwbComStaffMainSelect from '../orgStruct/ComStaffMainSelect';
import SwbComTreeMultiSelectList from './ComTreeMultiSelect';
/**
 *
 * @param queryFilter
 * @param callbackFunc
 */
import SwbServicerComListForSelect from './ServicerComListForSelect';
import SwbServicerXStaffSave from './ServicerXStaffSave';
import SwbServicerXStaffDetail from './ServicerXStaffDetail';
import SwbServicerXStaffListForSelect from './ServicerXStaffListForSelect';
import SwbServicerXngineerShopList from './ServicerXngineerShopList';

Vue.regist(SwbComStaffSelect);

Vue.regist(SwbComStaffForSelect);

Vue.regist(SwbServicerOrgTree);

Vue.regist(SwbComStaffImpCheck);

Vue.regist(SwbComImpCheck);

Vue.regist(SwbServicerEngineerListForSelect);

// comnFlag 通用标识
export function openComStaffSelectDlg(self, title, data, callback) {
    let theDlg = Vue.$showDialog({
        title: title,
        height: '70%',
        template: '<div>' +
            '<swb-com-staff-select :checkBox="checkBox" :comId="comId" :selectedIds="selectedIds" :defMsgReceiverId="defMsgReceiverId" :excludeAdmin="excludeAdmin" :xsFlag="xsFlag" ref="swb_com_staff_select"></swb-com-staff-select>' +
            '</div>',
        data: {
            checkBox: data.checkBox,
            comId: data.id,
            bizUnitId: data.bizUnitId,
            defMsgReceiverId: data.defMsgReceiverId,
            selectedIds: data.staffIds,
            excludeAdmin: data.excludeAdmin, // 是否不包含admin
            xsFlag: data.xsFlag
        },
        okClicked: function () {
            let result = this.$refs.swb_com_staff_select.getDlgResult() || {};
            if(data.comnFlag != null && data.comnFlag) {
                //
                callback(result, theDlg);
            } else {
                servicerApi.doSpecifyOperatorComReceiver(result, function (result) {
                    if(result.type == "info") {
                        self.$message.success("操作成功");
                        callback();
                        theDlg.close();
                    } else {
                        self.$message.error("操作失败");
                    }
                });
            }
            return false;
        },
        methods: {}
    });
}

// 当前公司及下级公司的员工列表
export function openThisOrDownComStaffForSelectDlg(eventMsgId, callback) {
    let self = this;
    Vue.$showDialog({
        title: '公司的员工列表',
        height: '70%',
        showCloseBtn: true,
        template: '<swb-com-staff-for-select :eventMsgId="eventMsgId" ref="swb_com_staff_for_select"></swb-com-staff-for-select>',
        data: {
            eventMsgId: eventMsgId
        },
        okClicked: function () {
            let result = this.$refs.swb_com_staff_for_select.getDlgResult() || {};
            if(result.type === 'info') {
                callback(result.data);
                return true;
            } else {
                self.$message.warning(result.message);
                return false;
            }
        }
    });
}

// 指定服务商的所有公司
export function openServicerComForSelectDlg(title, filter, checkBox, callback) {
    let servicerComIds = filter['servicerComIds'] || null;
    if(!Utils.isNoB(servicerComIds)) {
        delete filter.servicerComIds;
    }
    Vue.$showDialog({
        title: title,
        width: 1200,
        height: 600,
        showCloseBtn: true,
        template: '<swb-servicer-com-for-select :checkBox="checkBox" :filter="filter" :servicerComIds="servicerComIds" ref="swb_servicer_com_for_select"></swb-servicer-com-for-select>',
        data: {
            filter: filter,
            checkBox: checkBox,
            servicerComIds: servicerComIds,
        },
        okClicked: function () {
            let result = this.$refs.swb_servicer_com_for_select.getDlgResult() || {};
            if(result.type === 'info') {
                callback(result.data);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

export function openServicerComTreeSelectDlg(dlgConfig = {}, callback) {
    //
    if(Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if(typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let title = dlgConfig['title'] || "买家公司--选择";
    let enableSearch = dlgConfig['enableSearch'] || null; // 是否可以搜索
    let bizUnitId = dlgConfig['bizUnitId'] || null; // 业务单元
    let isRadio = dlgConfig['isRadio'] || false; // 是否可以单选
    let isShowIcon = dlgConfig['isShowIcon'] || false; // 是否可以伸缩
    let accordion = dlgConfig['accordion'] || false; // 是否手风琴模式
    let merchantId = dlgConfig['merchantId'] || null; // 零售商商户id
    let isCom = dlgConfig['isCom'] || false; // 零售商商户id
    let closed = dlgConfig['closed'] || false; // 是否闭店
    let dlgTheCol = dlgConfig['dlgTheCol'] || false;
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: 650,
        height: 600,
        showCloseBtn: true,
        //okVisible: true,
        // cancelText: "关闭",
        template: '<div class = "">' +
            '<swb-org-tree :closed="closed" :bizUnitId = "bizUnitId" :enableSearch="enableSearch" :isRadio="isRadio" :isShowIcon="isShowIcon" :accordion="accordion" :merchantId="merchantId" :isCom = "isCom"  ref="swb_retail_org_tree"></swb-org-tree>' +
            '</div>',
        data: {
            enableSearch: enableSearch,
            isRadio: isRadio,
            isShowIcon: isShowIcon,
            accordion: accordion,
            merchantId: merchantId,
            isCom: isCom,
            closed: closed,
            bizUnitId: bizUnitId
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_retail_org_tree.getDlgResult() || {};
            if(result.type == "info") {
                let retailerCom = result.data;
                //
                if(dlgTheCol) {
                    callback(retailerCom, theDlg);
                    return false;
                } else {
                    callback(retailerCom);
                }
            } else {
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

// 部门员工选择列表
export function openComStaffImpCheckDlg(comName, comId, callback) {
    let theDlg = Vue.$showDialog({
        title: '公司员工批量导入',
        width: 1200,
        height: 700,
        showCloseBtn: true,
        okText: '导入',
        template: '<swb-com-staff-imp-check :comName="comName" :comId="comId" ref="swb_com_staff_imp_check"></swb-com-staff-imp-check>',
        data: {
            comName: comName,
            comId: comId
        },
        okClicked: function () {
            let result = this.$refs.swb_com_staff_imp_check.getDlgResult() || {};
            if(result.type === 'info') {
                let comStaffImpInfoList = result.data;
                //
                callback(comStaffImpInfoList, theDlg);
            } else {
                Toast.show(result.message);
            }
            return false;
        }
    });
}

// 选人组件  - 指定机构的员工
export function openComStaffComnSelectDlg(comId, callback, includeSubComs, bizUnitId, isAll, isCom) {
    includeSubComs = Utils.isTrue(includeSubComs);
    //
    let theDlg = Vue.$showDialog({
        title: '人员选择',
        width: 900,
        height: 700,
        template: '<swb-com-staff-select :comId="comId" :bizUnitId="bizUnitId" :isAll="isAll" :isCom="isCom" :includeSubComs="includeSubComs" ref="swb_com_staff_select"></swb-com-staff-select>',
        data: {
            comId: comId,
            includeSubComs: includeSubComs,
            bizUnitId: bizUnitId,
            isAll: isAll,
            isCom: isCom,
        },
        okClicked: function () {
            let result = this.$refs.swb_com_staff_select.getDlgResult() || {};
            callback(result, theDlg);
            //
            return false;
        },
        methods: {}
    });
}

Vue.regist(SwbComStaffMainSelect);

// 当前公司及下级公司的员工列表 左侧组织架构树-右侧人员列表
export function openComStaffMainForSelectDlg(dlgConfig = {}, callback) {
    //
    let defComId = dlgConfig['defComId'] || null; // 默认显示的公司人员
    let isCom = dlgConfig['isCom'] || null; // 是否获取全部的公司
    let isSelectThisLevel = dlgConfig['isSelectThisLevel'] || null; // 本级是否可选
    let title = dlgConfig['title'] || "公司的员工列表"; // 本级是否可选
    let checkBox = Utils.isTrue(dlgConfig['checkBox']);
    let selectedIds = dlgConfig['selectedIds'] || [];
    //
    let theDlg = Vue.$showDialog({
        title: title,
        height: 800,
        width: 1300,
        showCloseBtn: true,
        template: '<swb-com-staff-main-select :defComId="defComId" :hidden="true" :isCom="isCom" :isSelectThisLevel="isSelectThisLevel" :checkBox="checkBox" :selectedIds="selectedIds" ref="swb_com_staff_main_select"></swb-com-staff-main-select>',
        data: {
            defComId: defComId,
            isCom: isCom,
            isSelectThisLevel: isSelectThisLevel,
            checkBox: checkBox,
            selectedIds: selectedIds
        },
        okClicked: function () {
            let result = this.$refs.swb_com_staff_main_select.getDlgResult() || {};
            if(result.type === 'info') {
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

//机构设备导入检查
export function openComImpCheckDlg(bizDepartFlag, bizUnitType, comId, comName, callback) {
    let title = '机构';
    if (bizDepartFlag) {
        title = '部门';
    }
    let theDlg = Vue.$showDialog({
        title: "批量导入 -- " + title,
        width: 1000,
        height: 750,
        showCloseBtn: true,
        template: '<swb-com-imp-check :bizDepartFlag="bizDepartFlag" :bizUnitType="bizUnitType" ref="swb_com_imp_check"></swb-com-imp-check>',
        data: {
            bizDepartFlag: bizDepartFlag,
            bizUnitType: bizUnitType
        },
        methods: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_com_imp_check.getDlgResult() || {};
            //
            if(result.type == "info") {
                this.$confirm("确定对【" + comName + "】导入" + title, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoading = MsgBox.loading();
                    let postData = {};
                    postData.id = comId;
                    postData.comSons = result.data;
                    servicerApi.saveServicerComBatch(postData, function (result) {
                        theLoading.close();
                        console.log(result);
                        if(result.type == 'info') {
                            callback(result.data);
                            theDlg.close();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
    });
}

import SwbComDetail from './ComDetail';

Vue.regist(SwbComDetail);

export function openComDetailDlg(comId, title) {
    title = title || '机构详情';
    Vue.$showDialog({
        title: title,
        width: 800,
        height: 800,
        okVisible: false,
        cancelText: '关闭',
        showCloseBtn: true,
        template: '<swb-servicer-com-detail :comId="comId"></swb-servicer-com-detail>',
        data: {
            comId: comId
        }
    });
}

// 服务工程师 - 选择
export function openServicerEngineerListForSelectListDlg(params, callback) {
    let ssuIdList = params.ssuIdList || [];
    let servicerShopId = params.servicerShopId || null;
    let goodsCatId = params.goodsCatId || null;
    let servcCatId = params.servcCatId || null;
    let servcId = params.servcId || null;
    let servcType = params.servcType;
    let retailerShopId = params.retailerShopId || null;
    let disabled = params.disabled != null ? params.disabled : false;
    let isRadio = false;
    let onlyShowAll = false;
    if(!Utils.isNoB(params.isRadio)) {
        isRadio = params.isRadio;
    }
    if(!Utils.isNoB(params.onlyShowAll)) {
        onlyShowAll = params.onlyShowAll;
    }
    Vue.$showDialog({
        title: '服务工程师 - 选择',
        width: 1200,
        height: 750,
        showCloseBtn: true,
        template: '<swb-servicer-engineer-list-for-select :disabled="disabled" :isRadio="isRadio" :onlyShowAll="onlyShowAll" :ssuIdList="ssuIdList" :servicerShopId="servicerShopId" :goodsCatId="goodsCatId" :servcCatId="servcCatId" :servcId="servcId" :servcType="servcType" :retailerShopId="retailerShopId" ref="swb_servicer_engineer_list_select"></swb-servicer-engineer-list-for-select>' +
            '</div>',
        data: {
            ssuIdList: ssuIdList,
            servicerShopId: servicerShopId,
            goodsCatId: goodsCatId,
            servcCatId: servcCatId,
            servcId: servcId,
            servcType: servcType,
            retailerShopId: retailerShopId,
            isRadio: isRadio,
            onlyShowAll: onlyShowAll,
            disabled: disabled
        },
        okClicked: function () {
            let result = this.$refs.swb_servicer_engineer_list_select.getDlgResult() || {};
            if(result.type === 'info') {
                let engineerList = result.data;
                //
                callback(engineerList);
            } else {
                Toast.show(result.message);
                return false;
            }

        }
    });
}

Vue.regist(SwbComTreeMultiSelectList);

//TODO displayDataList [{comId,comId1,comId2,comId3}] 回显必传
export function openServicerComTreeMultiSelectDlg(dlgConfig = {}, displayDataList = [], callback) {
    if(Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if(typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let merchantId = dlgConfig['merchantId'];
    let noPostFilters = dlgConfig['noPostFilters'] || false;
    let showCheckboxLevel1 = dlgConfig['showCheckboxLevel1'] || false;
    let showCheckboxLevel2 = dlgConfig['showCheckboxLevel2'] || false;
    let showCheckboxLevel3 = dlgConfig['showCheckboxLevel3'] || false;
    let checkStrictly = dlgConfig['checkStrictly'] || false;
    let model = dlgConfig['model'] || null;
    if(model == null) {
        model = {};
        model.comIdColumn = "comId"; //
        model.comNameColumn = "comName";
        model.comLevelColumn = "comLevel";
    }
    let defaultCheckedItems = displayDataList || [];
    //
    Vue.$showDialog({
        title: '服务商机构 - 选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        //okVisible: true,
        // cancelText: "关闭",
        template: '<div class = "">' +
            '<swb-servicer-com-tree-multi-select :noPostFilters = "noPostFilters" :merchantId="merchantId" :showCheckboxLevel1="showCheckboxLevel1" :showCheckboxLevel2 = "showCheckboxLevel2" :showCheckboxLevel3="showCheckboxLevel3" :checkStrictly = "checkStrictly" :defaultCheckedItems = "defaultCheckedItems" :model = "model" ref="swb_servicer_com_tree_multi_select"></swb-retailer-com-tree-multi-select>' +
            '</div>',
        data: {
            noPostFilters: noPostFilters,
            merchantId: merchantId,
            showCheckboxLevel1: showCheckboxLevel1,
            showCheckboxLevel2: showCheckboxLevel2,
            showCheckboxLevel3: showCheckboxLevel3,
            checkStrictly: checkStrictly,
            defaultCheckedItems: defaultCheckedItems,
            model: model
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_servicer_com_tree_multi_select.getDlgResult() || {};
            //
            callback(result);
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

Vue.regist(SwbServicerComListForSelect);

//
export function openServicerComListForSelectDlg(queryFilter, callbackFunc) {
    let checkedComList = queryFilter['checkedComList'] || [];
    let checkBox = queryFilter['checkBox'];
    let merchantId = queryFilter['merchantId'];
    let comLevel = queryFilter['comLevel'];
    let comId = queryFilter['comId'];
    let orgType = queryFilter['orgType'];
    let shopFlag = queryFilter['shopFlag'] != null ? queryFilter['shopFlag'] : null;
    let bizUnitLevels = queryFilter['bizUnitLevels'] || [];
    let bizUnitType = queryFilter['bizUnitType'] || [];
    let title = queryFilter['title'] ? queryFilter['title'] : '服务商机构 - 选择';
    let disabledIds = queryFilter['disabledIds'] || [];
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: -400,
        height: 750,
        showCloseBtn: true,
        template: '<swb-servicer-com-list-for-select :bizUnitLevels="bizUnitLevels" :bizUnitType="bizUnitType" :disabledIds="disabledIds" :comId="comId" :orgType="orgType" :comLevel="comLevel" :shopFlag="shopFlag" :checkBox="checkBox" :checkedComList="checkedComList" :merchantId="merchantId" ref="swb_servicer_com_list_for_select"></swb-servicer-com-list-for-select>',
        data: {
            checkBox: checkBox,
            checkedComList: checkedComList,
            merchantId: merchantId,
            comId: comId,
            comLevel: comLevel,
            shopFlag: shopFlag,
            orgType: orgType,
            disabledIds: disabledIds,
            bizUnitLevels: bizUnitLevels,
            bizUnitType: bizUnitType
        },
        okClicked: function () {
            let selfDlg = this;
            let result = selfDlg.$refs.swb_servicer_com_list_for_select.getDlgResult() || {};
            if(result.type === 'info') {
                let retailerComList = result.data;
                callbackFunc(retailerComList, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

Vue.regist(SwbServicerXStaffSave);

// 商户员工保存
export function openServicerXStaffSaveDlg(params, callback) {
    let id = params['id'] || null;
    let phoneNo = params['phoneNo'] || null;
    let theDlg = Vue.$showDialog({
        title: '商户员工 - 保存',
        height: '70%',
        template: '<div>' +
            '<swb-servicer-xStaff-save :id="id" :phoneNo="phoneNo" ref="swb_servicer_xstaff_save"></swb-servicer-xStaff-save>' +
            '</div>',
        data: {
            id: id,
            phoneNo: phoneNo
        },
        okClicked: function () {
            let result = this.$refs.swb_servicer_xstaff_save.getDlgResult() || {};
            if(result.type == 'info') {
                //
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        methods: {}
    });
}

Vue.regist(SwbServicerXStaffDetail);

// 商户人员保存
export function openServicerXStaffDetailDlg(id) {
    let theDlg = Vue.$showDialog({
        title: '商户人员 - 详情',
        height: '70%',
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div>' +
            '<swb-servicer-xStaff-detail :id="id" ref="swb_servicer_xstaff_detail"></swb-servicer-xStaff-detail>' +
            '</div>',
        data: {
            id: id
        },
        methods: {}
    });
}

Vue.regist(SwbServicerXStaffListForSelect);

export function openServicerXstaffListForSelectListDlg(params, callback) {
    Vue.$showDialog({
        title: '商户员工 - 选择',
        width: 1200,
        height: 800,
        showCloseBtn: true,
        template: '<swb-servicer-xStaff-list-for-select ref="swb_servicer_xStaff_list_for_select"></swb-servicer-xStaff-list-for-select>',
        data: {},
        okClicked: function () {
            let result = this.$refs.swb_servicer_xStaff_list_for_select.getDlgResult() || {};
            if(result.type === 'info') {
                callback(result.data);
            } else {
                Toast.show(result.message);
                return false;
            }
        }
    });
}

Vue.regist(SwbServicerXngineerShopList);

export function openServicerXngineerShopListDlg(params, callback) {
    let xngineerId = params['xngineerId'] || null;
    Vue.$showDialog({
        title: '商户工程师-分配网点',
        width: 1200,
        height: 750,
        showCloseBtn: true,
        cancelText: "关闭",
        okVisible: false,
        template: '<swb-servicer-xngineer-shop-list :xngineerId="xngineerId" ref="swb_servicer_xngineer_shop_list"></swb-servicer-xngineer-shop-list>',
        data: {
            xngineerId: xngineerId
        },
        okClicked: function () {
            let result = this.$refs.swb_servicer_xngineer_shop_list.getDlgResult() || {};
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/orgStruct/selectDlg.js
// module id = 19
// module chunks = 1